<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false"
  [frontDispFlag]="false">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">企画書データ出力</th>
    <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <div class="column-list">
          <label class="list-input-title">受注コード</label>
          <div class="list-input-content">
            <div class="element-row">
              <app-order-code-text-input id="txti_OrderCodeFrom" #txti_OrderCodeFrom [subid]="'txti_OrderCodeFrom'"
                [(ngModel)]="kymw1301Model.orderCodeFrom" [required]="true" [catalogIDField]="lbl_DelivCatalogIDFrom"
                [forcedEnabledMode]="'true'" [autofocus]="true" [tabindex]="0"
                (ngModelChange)="eventOrderCodeMediumType_CHANGEHandler()">
              </app-order-code-text-input>
              <label>～</label>
              <app-order-code-text-input id="txti_OrderCodeTo" #txti_OrderCodeTo [subid]="'txti_OrderCodeTo'"
                [(ngModel)]="kymw1301Model.orderCodeTo" [required]="true" [catalogIDField]="lbl_DelivCatalogIDTo"
                [forcedEnabledMode]="'true'" [tabindex]="0"
                (ngModelChange)="eventOrderCodeMediumType_CHANGEHandler()">
              </app-order-code-text-input>
            </div>
          </div>

          <label class="list-input-title">配達企画回（翌週）</label>
          <div class="list-input-content">
            <div class="element-row">
              <input type="text" class="deliv-catalog" id="lbl_DelivCatalogIDFrom" #lbl_DelivCatalogIDFrom
                readonly/>
              <label>～</label>
              <input type="text" class="deliv-catalog" id="lbl_DelivCatalogIDTo" #lbl_DelivCatalogIDTo
                readonly/>
            </div>
          </div>

          <label class="list-input-title">媒体</label>
          <div class="list-input-content">
            <app-plan-medium-type-combo-box id="cmb_MediumType" #cmb_Medium [subid]="'cmb_Medium'"
              [(ngModel)]="kymw1301Model.mediumType" [required]="false" [blank]="true" [forcedEnabledMode]="'true'"
              [tabindex]="0" (change)="eventOrderCodeMediumType_CHANGEHandler()" style="width: 100%;">
            </app-plan-medium-type-combo-box>
          </div>

          <label class="list-input-title">部門</label>
          <div class="list-input-content" style="height: 108px;">
            <app-classifications-list id="lst_Classifications" #lst_Classifications
              [subid]="'lst_Classifications'" [forcedEnabledMode]="'true'" [tabindex]="0">
            </app-classifications-list>
          </div>

          <label class="list-input-title">Ｐコード</label>
          <div class="list-input-content">
            <input type="text" class="text-label-normal list-input-content pcode" id="txti_PCode" [(ngModel)]="kymw1301Model.pCode"
              plessInputTextSub [restrict]="'[P0-9]'" [maxlength]="8" [tabindex]="0" />
          </div>

          <label class="list-input-title">生協</label>
          <div class="list-input-content">
            <app-coop-code-combo-box id="cmb_CoopCode" #cmb_CoopCode [subid]="'cmb_CoopCode'"
              [(ngModel)]="kymw1301Model.coopCode" [forcedEnabledMode]="'true'" [tabindex]="0">
            </app-coop-code-combo-box>
          </div>

          <label class="list-input-title">ページ</label>
          <div class="list-input-content">
            <input type="text" [(ngModel)]="kymw1301Model.pageNumFrom" style="width: 3rem;"
              plessInputTextSub [maxlength]="3" [restrict]="'[0-9]'" [halfOnly]="true">
            <label>～</label>
            <input type="text" [(ngModel)]="kymw1301Model.pageNumTo" style="width: 3rem;"
              plessInputTextSub [maxlength]="3" [restrict]="'[0-9]'" [halfOnly]="true">
          </div>

          <label class="list-input-title">注文コード</label>
          <div class="list-input-content" style="width: 6rem;">
            <input type="text" [(ngModel)]="kymw1301Model.orderNum"
              plessInputTextSub [maxlength]="6" [restrict]="'[0-9]'" [halfOnly]="true">
          </div>

          <label class="list-input-title">特集コード</label>
          <div class="list-input-content">
            <select id="cmb_featureCode" #cmb_featureCode [(ngModel)]="kymw1301Model.selectFeatureCode" forcedEnabledMode="true">
              <option value=""></option>
              <ng-template ngFor let-item [ngForOf]="kymw1301Model.featureThemaList">
                <option value="{{item.featureCode}}">{{item.featureCode}}：{{item.featureName}}</option>
              </ng-template>
            </select>
          </div>

          <label class="list-input-title">マーク</label>
          <div class="list-input-content element-row">
            <app-mark-code-text-input [(ngModel)]="kymw1301Model.markCode1" [forcedEnabledMode]="'true'"></app-mark-code-text-input>
            <app-mark-code-text-input [(ngModel)]="kymw1301Model.markCode2" [forcedEnabledMode]="'true'"></app-mark-code-text-input>
            <app-mark-code-text-input [(ngModel)]="kymw1301Model.markCode3" [forcedEnabledMode]="'true'"></app-mark-code-text-input>
            <app-mark-code-text-input [(ngModel)]="kymw1301Model.markCode4" [forcedEnabledMode]="'true'"></app-mark-code-text-input>
            <app-mark-code-text-input [(ngModel)]="kymw1301Model.markCode5" [forcedEnabledMode]="'true'"></app-mark-code-text-input>
          </div>

          <label class="list-input-title">Ｗ掲載除く</label>
          <div class="list-input-content">
            <app-checkbox-label label="対象" [(ngModel)]="kymw1301Model.wPublishFlag" [forcedEnabledMode]="'true'"></app-checkbox-label>
          </div>

          <label class="list-input-title">Ｗ掲載のみ</label>
          <div class="list-input-content">
            <app-checkbox-label label="対象" [(ngModel)]="kymw1301Model.multiPublishFlag" [forcedEnabledMode]="'true'"></app-checkbox-label>
          </div>
          
        </div>
      </div>
    </td>
  </tr>

  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <button id="btn_Out" class="btn-primary" (click)="eventOut_CLICKHandler()" forcedEnabledMode="true"
            [tabindex]="0">出力</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="onClickWindowClose()"></button>
        </div>
      </td>
    </tr>
  </tfoot>
</table>